import React from "react";
import Settings from "@material-ui/icons/Settings";
import Quotes from "@material-ui/icons/Receipt";
import AddCircle from "@material-ui/icons/AddCircle";
import Explore from "@material-ui/icons/Explore";

const menuItems = [
  {
    icon: <Quotes />,
    text: "NavBar.Quotes",
    path: "/overview",
    name: "Quotes",
  },
  {
    icon: <AddCircle />,
    text: "NavBar.NewQuote",
    path: "/quotes/new/client",
    name: "NewQuote",
    visible: (userData) => !userData?.userRights?.hasEstimatorOnlyRight,
  },
  {
    icon: <Explore />,
    text: "NavBar.NewEstimation",
    path: "/estimations/new/assets",
    name: "NewEstimation",
  },
  {
    icon: <Settings />,
    text: "NavBar.Settings",
    path: "/settings",
    name: "Settings",
    visible: (userData) => userData?.userRights?.hasAdminUserRight,
  },
];

export default menuItems;
